import React from 'react';
import IconButton from '@material-ui/core/IconButton'
import { useHistory } from 'react-router-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const BackToHome = () => {
  const history = useHistory()

  return (
    <IconButton
      color="primary"
      aria-label="Voltar"
      onClick={() => {
        history.goBack()
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  );
}

export default BackToHome
